import { render } from "./MatchContent2COPA.vue?vue&type=template&id=3ce6e360&scoped=true"
import script from "./MatchContent2COPA.vue?vue&type=script&lang=js"
export * from "./MatchContent2COPA.vue?vue&type=script&lang=js"

import "./MatchContent2COPA.vue?vue&type=style&index=0&id=3ce6e360&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce6e360"]])

export default __exports__